import { ArrowForward } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useState } from 'react';
import { FormState } from 'react-hook-form';
import { SidebarAccordion } from 'src/components/accordion';
import {
  ResourceSelectorSidebar,
  SwitchButtonWidget,
} from 'src/components/widget';
import { ResourceType } from 'src/components/widget/resourceSelectorWidget/resourceSelectorSidebarWidget/ResourceSelectorSidebar.interface';
import { lang } from 'src/utils';

import {
  IMobileOrderPay,
  ISingleShelfConfig,
} from '../../SingleShelf.interface';

interface IProps {
  mop?: IMobileOrderPay;
  formState: FormState<ISingleShelfConfig>;
  handleOnChange: (key: string, value: unknown) => void;
  hasTriedSaving?: boolean;
  componentDetails: any;
}
const hasBackgroundImage = (mop?: { background?: string }): boolean =>
  !!mop?.background?.trim();

export const MobileUserAccordion = ({
  mop,
  formState,
  hasTriedSaving,
  componentDetails,
  handleOnChange,
}: IProps) => {
  const [MobileUserOn, setMobileUserOn] = useState(hasBackgroundImage(mop));
  const [background, setBackground] = useState(mop?.background || '');
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const items = [
    {
      label: lang.background,
      onLabelClick: onToggleBackgroundDrawer,
      content: <div />,
      chevronIcon: <ArrowForward />,
      disabledExpand: true,
      hasError: hasTriedSaving
        ? !hasBackgroundImage(componentDetails?.config?.mop)
        : false,
    },
  ];

  const onMobileUserChange = (value: boolean) => {
    setMobileUserOn(value);
    handleOnChange('mop', value ? { background } : undefined);
  };

  const onBackgroundChange = (value: string) => {
    setBackground(value);
    handleOnChange('mop.background', value);
  };

  return (
    <>
      <Box sx={{ padding: '0 26px' }}>
        <SwitchButtonWidget
          value={MobileUserOn}
          onChange={(value) => onMobileUserChange(value as boolean)}
        />
      </Box>

      {MobileUserOn && <SidebarAccordion items={items} />}

      <ResourceSelectorSidebar
        label={lang.background}
        type={ResourceType.BACKGROUND}
        defaultAssetName={mop?.background}
        openResourceSelectorDrawer={openBackgroundDrawer}
        onToggleResourceSelectorDrawer={onToggleBackgroundDrawer}
        onChange={(value) => onBackgroundChange(value as string)}
        hasError={!!formState.errors?.mop?.background}
        error={formState.errors?.mop?.background?.message || false}
      />
    </>
  );
};
